import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";

export const getListGeneralRequest = (async (searchString, orderBy) => await http({
    url: ENDPOINTS.cartable.GeneralRequestClassification.browse,
    method: 'get',
    params: {
        searchString: searchString,
        orderBy: orderBy
    }
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)


export const getGeneralRequest = (async (id) => await http({
    url: ENDPOINTS.cartable.GeneralRequestClassification.load,
    method: 'get',
    params: {Id : id}
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)


export const deleteGeneralRequest =  (id) =>  http({
    url: ENDPOINTS.cartable.GeneralRequestClassification.browse,
    method: 'delete',
    params: {Id : id}

}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject( err);
})


export const postGeneralRequest = (data) => http({
    url: ENDPOINTS.cartable.GeneralRequestClassification.browse,
    method: 'post',
    data:data
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})


export const putGeneralRequest = (data) => http({
    url: ENDPOINTS.cartable.GeneralRequestClassification.browse,
    method: 'put',
    data:data
}).then((res) => {

    return res.data
}).catch((err) => {
    return Promise.reject( err);
})

